import { render, staticRenderFns } from "./Tablon.vue?vue&type=template&id=053a8ef3"
import script from "./Tablon.vue?vue&type=script&lang=js"
export * from "./Tablon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports